import React from 'react';
import { KeywordAdClicksColumnChart } from 'src/components/BeaconV2Components/ExperimentalLayout/Segments/KeywordsSearch/KeywordAdClicksColumnChart';
import KeywordAdClicksSpline from 'src/components/BeaconV2Components/ExperimentalLayout/Segments/KeywordsSearch/KeywordAdClicksSpline';
import KeywordSearchOrganicTrafficSpline from 'src/components/BeaconV2Components/ExperimentalLayout/Segments/KeywordsSearch/KeywordSearchOrganicTrafficSpline';
import { TopicFilter } from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/Filters/constants';
import { useTopicBuilderActions } from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/Store/useTopicBuilderStore';
import TopicBuilderColumnChart from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/Visualizations/TopicBuilderColumnChart';
import useTopicAdvancedRequestBuilder from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/hooks/useTopicAdvancedRequestBuilder';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import MetricListContainer from 'src/components/BeaconV2Components/MetricList/MetricListContainer';
import { KeywordColumnDefinition } from 'src/components/BeaconV2Components/MetricList/headColumnDefinitions';
import { SlCancelButton } from 'src/components/BeaconV2Components/SlButtons/SlCancelButton';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';

/**
 * Renders a table containing keywords and their metrics and additional visualizations that are filtered via sidebar.
 */
export const TopicBuilderCreateResults = () => {
  const [hoveredIndex, setHoveredIndex] = React.useState(null);

  const salesKeywordSearchRequestBuilder = useTopicAdvancedRequestBuilder('retailSales');
  const trafficKeywordSearchRequestBuilder = useTopicAdvancedRequestBuilder('traffic');
  const advertisingKeywordSearchRequestBuilder = useTopicAdvancedRequestBuilder('advertising');

  const { setFilters } = useTopicBuilderActions();
  // Handles quick exclude button click
  const handleExcludeButtonClick = (term: string) => {
    setFilters(({ add }) => add({ key: TopicFilter.ExcludedKeywords, values: [term] }));
  };

  const additionalColumnDefs = [
    {
      headerName: '',
      tableColumnProps: {
        style: {
          width: '50px'
        }
      },
      valueFormatter: (_, row, index) => {
        const { searchTerm } = row;

        if (hoveredIndex === index) {
          return <SlCancelButton onClick={() => handleExcludeButtonClick(searchTerm)} />;
        } else {
          return null;
        }
      }
    }
  ];
  return (
    <Flex gap={BEACON_CHART_SPACING} flexDirection="column">
    <div>
      <MetricListContainer
        appTableProps={{
          onRowEnter: (_u, _w, index) => setHoveredIndex(index),
          onRowLeave: () => setHoveredIndex(null)
        }}
        additionalColumnDefs={additionalColumnDefs}
        loading={false}
        headColumnDefinition={KeywordColumnDefinition}
        fields={[
          {
            name: 'organicClicks',
            comparisonFormatter() {
              return null;
            }
          },
          {
            name: 'adClicks',
            comparisonFormatter() {
              return null;
            }
          },
          {
            name: 'totalClicks',
            comparisonFormatter() {
              return null;
            }
          },
          {
            name: 'adSpend',
            comparisonFormatter() {
              return null;
            }
          }
        ]}
        showHeader={false}
        showGrid={false}
        indexName="traffic"
        sortFieldName="totalClicks"
        groupBy="searchTerm"
        skeletonRows={20}
        useTableDataProps={{
          buildRequest: salesKeywordSearchRequestBuilder()
        }}
        className="topic-builder-keyword-table"
      />
      </div>
      <KeywordSearchOrganicTrafficSpline builderFunction={trafficKeywordSearchRequestBuilder} />
      <TopicBuilderColumnChart builderFunction={trafficKeywordSearchRequestBuilder} />
      <KeywordAdClicksSpline builderFunction={advertisingKeywordSearchRequestBuilder} />
      <KeywordAdClicksColumnChart builderFunction={advertisingKeywordSearchRequestBuilder} />
    </Flex>
  );
};
